import React, { FormEvent } from 'react';
import { RouteComponentProps } from 'react-router';
import QRCode from 'qrcode.react';
import styled from 'styled-components';
import LottieLogo from './LottieLogo';
import config from '../config';

const SQR = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  width: 90vw;
`;

const SLogoImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: inherit;
  height: auto;
  margin: 0 0 4vh 0;
`;

interface IQRProps extends RouteComponentProps {
  pollId: string;
}

export default class QR extends React.Component<IQRProps> {
  public baseUrl = config.baseUrl;

  goToPollResults = (event: FormEvent, pollId: string) => {
    event.preventDefault();
    const encodedPollId = encodeURIComponent(pollId);
    this.props.history.push(`/admin/${encodedPollId}/results`);
  };

  render() {
    const { pollId } = this.props;
    const encodedPollId = encodeURIComponent(pollId);

    return (
      <SQR className='QR'>
        <SLogoImageContainer className='SLogoImageContainer'>
          <div style={{ margin: '0 0 0 0' }}>
            <LottieLogo height={'40vw'} width={'40vw'} />
          </div>
          <QRCode
            value={`${this.baseUrl}/p/${encodedPollId}`}
            size={1600}
            style={{ width: '30vw', height: 'auto', margin: '5vw' }}
          />
        </SLogoImageContainer>
      </SQR>
    );
  }
}
